import { FC } from "react";

import { Stack } from "@mui/material";
import { FormCategory } from "@simplyk/common";

import { ThemedPeerCredibilityAttendanceChip } from "./ThemedPeerCredibilityAttendanceChip";
import { ThemedPeerCredibilityRemainingTicketsChip } from "./ThemedPeerCredibilityRemainingTicketsChip";

type ThemedPeerCredibilityTicketingChipsProps = {
  totalCount: number;
  weeklyCount: number;
  formCategory: FormCategory;
  remainingTickets?: number;
};

export const ThemedPeerCredibilityTicketingChips: FC<ThemedPeerCredibilityTicketingChipsProps> = ({
  totalCount,
  weeklyCount,
  formCategory,
  remainingTickets,
}) => {
  return (
    <Stack direction="row" spacing={1}>
      <ThemedPeerCredibilityAttendanceChip
        totalCount={totalCount}
        weeklyCount={weeklyCount}
        formCategory={formCategory}
      />

      {remainingTickets !== undefined && (
        <ThemedPeerCredibilityRemainingTicketsChip remainingTickets={remainingTickets} formCategory={formCategory} />
      )}
    </Stack>
  );
};
